export * from './fieldList';
import { FunctionTypes } from '../../../components/ContributorSection/helpers';

/** test ids for form and sections inside it */
export var SCHOLARLY_FORM_TEST_ID = "scholarly-form-test-id";
export var SCHOLARLY_FORM_PUB_INFO_TEST_ID = 'scholarly-form-pub-info-test-id';
export var SCHOLARLY_FORM_PUB_INFO_SECTION_NAME = 'pubonline';
export var SCHOLARLY_FORM_PUB_INFO_SECTION_TITLE = 'Online Publication info';
export var PROJECT_TITLE_LABEL = 'Project title';
export var PROJECT_TITLE_INPUT_TEST_ID = 'project-title-input-test-id';
export var PROJECT_TITLE_HELPER_TEXT = 'Add only if different from Website name.';
export var CONTRIBUTOR_ROLE_OPTIONS = [FunctionTypes.AUTHOR, FunctionTypes.EDITOR, FunctionTypes.COMPILER, FunctionTypes.TRANSLATOR];